import { gql } from '__generated__';

export default gql(`
  mutation DeactivateCoupon($id: ID!) {
    deactivateCoupon(id: $id) {
      id
      active
    }
  }
`);
